import { formatUsdValue } from '@/utils/helpers';

export default {
  props: {
    amount: {
      type: [String, Number],
      default: 0,
    },
    feePercent: {
      type: Number,
      default: 0,
    },
    feeFreeCap: {
      type: [String, Number],
      default: 0,
    },
    feeDiscountEligibility: {
      type: Boolean,
      default: false,
    },
    feeCap: {
      type: Number,
      default: null,
    },
    prefix: {
      type: String,
      default: '',
    },
  },
  computed: {
    freeTierAmount() {
      return Number(this.feeFreeCap);
    },
    isReduced() {
      return Number(this.amount) > this.freeTierAmount;
    },
    statusLabel() {
      if (!this.feePercent) {
        return 'No fees';
      }
      if (this.feeDiscountEligibility) {
        return this.isReduced ? 'Reduced fees' : 'No fees';
      }
      return `${this.feePercent}% fee`;
    },
    feeCapDisplayMessage() {
      if (!this.feePercent || !this.feeCap || (this.feeDiscountEligibility && !this.isReduced)) {
        return '';
      }
      return `up to a maximum of $${formatUsdValue(this.feeCap, { trimWhole: true })}`;
    },
  },
};
